<div class="price-list">
  <h3>{{ title() }} - {{ itemName() }}</h3>
  <ul>
    @for (price of prices(); track price.itemId) {
      <li>
        <span class="customer">{{ price.itemName[lang] }}</span>
        <span class="price">{{ price.price }} {{ price.unit }}</span>
        <span class="valid-until">{{ price.validFrom | date: 'd.M.yyyy' }}</span>
        <button mat-icon-button (click)="editPrice(price)">
          <mat-icon class="edit-icon">edit</mat-icon>
        </button>
        <button mat-icon-button (click)="deletePrice(price)">
          <mat-icon class="delete-icon">close</mat-icon>
        </button>
      </li>
    } @empty {
      <li class="no-prices">{{ 'PRICE_LIST.NO_PRICES_ADDED' | translate }}</li>
    }
  </ul>
</div>
